export default __webpack_public_path__ + "_/images/freespins/freespins-20-a06aa96f1c87f874c0abde28b4d9af7bfe6c052c81995e734f78b3c38fe3ce1c.png";